import { render, staticRenderFns } from "./UserMobileCard.vue?vue&type=template&id=662a071a&scoped=true&"
import script from "./UserMobileCard.vue?vue&type=script&lang=js&"
export * from "./UserMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662a071a",
  null
  
)

export default component.exports